import {DirectiveOptions} from "vue";

const directive: DirectiveOptions = {
    async inserted(el: HTMLElement, binding, vnode) {
     el.focus();
    },
  };
export default directive;
